import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiAward, FiShield, FiUsers, FiClock, FiSettings, FiMapPin } = FiIcons;

const WhyChooseUs = () => {
  const features = [
    {
      icon: FiAward,
      title: '10+ Years Experience',
      description: 'Over a decade of teaching experience in Greater London with proven results.'
    },
    {
      icon: FiShield,
      title: 'Safety First',
      description: 'Teaching the latest safe driving techniques with safety as our top priority.'
    },
    {
      icon: FiUsers,
      title: 'Qualified Instructors',
      description: 'Friendly, fully qualified instructors who adapt to your learning style.'
    },
    {
      icon: FiClock,
      title: 'Flexible Timing',
      description: 'Flexible lesson timings and course options to fit your schedule.'
    },
    {
      icon: FiSettings,
      title: 'Manual & Automatic',
      description: 'Both manual and automatic lessons available to suit your preference.'
    },
    {
      icon: FiMapPin,
      title: 'Coverage Areas',
      description: 'Greater London (Ashford, Feltham, Hounslow, Staines). Surrey (Addlestone, Weybridge, Walton on Thames, NewHaw, Chertsey, Virginia Water).'
    }
  ];

  return (
    <section className="py-20 bg-white dark:bg-gray-900 transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-4 transition-colors">
            Why Choose Alpha Driving School?
          </h2>
          <p className="text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto transition-colors">
            We're committed to helping you become a safe, confident driver with personalized instruction and proven methods.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              whileHover={{ y: -5 }}
              className="bg-gray-50 dark:bg-gray-800 rounded-xl p-8 hover:shadow-lg transition-all duration-300 border border-gray-100 dark:border-gray-700 min-h-[280px] flex flex-col"
            >
              <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center mb-6">
                <SafeIcon icon={feature.icon} className="w-6 h-6 text-white" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-3 transition-colors">
                {feature.title}
              </h3>
              {feature.title === 'Coverage Areas' ? (
                <div className="text-gray-600 dark:text-gray-300 leading-relaxed transition-colors flex-grow">
                  <p className="mb-2">Greater London (Ashford, Feltham, Hounslow, Staines).</p>
                  <p>Surrey (Addlestone, Weybridge, Walton on Thames, NewHaw, Chertsey, Virginia Water).</p>
                </div>
              ) : (
                <p className="text-gray-600 dark:text-gray-300 leading-relaxed transition-colors flex-grow">
                  {feature.description}
                </p>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;